
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The HTTP status code returned by the subscription endpoint.`}</p>
    <p>{`When an HTTP response wasn't received a synthetic status code will be generated:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`For `}<inlineCode parentName="p">{`InvalidUrl`}</inlineCode>{` the status code will be set to `}<inlineCode parentName="p">{`400`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For `}<inlineCode parentName="p">{`RequestTimeout`}</inlineCode>{` the status code will be set to `}<inlineCode parentName="p">{`504`}</inlineCode>{`.`}</p>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;